import React, {useState, useEffect} from "react"
import { Link } from "react-router-dom"
import { Row, Col, Card } from "reactstrap"

//Import Images
import profileImg from "../../assets/images/profile-img.png"

function CardWelcome(props) {
  const [username, setUsername] = useState("")
  const [role, setrole] = useState("")
  const [employeeNo, setEmployeeNo] = useState("")

  useEffect(() => {
    if (localStorage.getItem("authMildUser")) {
      const obj = JSON.parse(localStorage.getItem("authMildUser"));
      setUsername(obj.staffname)
      setEmployeeNo(obj.uid)
      setrole(obj.title)
    }
  }, [])
  return (
    <React.Fragment>
    <Col xl="4">
      <Card className="bg-primary bg-soft">
        <div>
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">You can now:</h5>

                <ul className="ps-3 mb-0">
                <li className="py-1"><Link to="/leave-requests">Apply For Leave</Link></li>
                  <li className="py-1"><Link to="/individual-performance-agreement">Create Staff Perf. Agreement</Link></li>
                  <li className="py-1"><Link to="#">Submit Timesheets</Link></li>
                  <li className="py-1"><Link to="/profile">View Bio-Data</Link></li>
                  <li className="py-1"><Link to="#">Raise D&G Case</Link></li>
                </ul>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
      </Card>
    </Col>
  </React.Fragment>
  );
}

export default CardWelcome;